import Tabs from "@/components/Tabs";
import { useCanManageApplications, useCanViewPersonMembershipBool } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const { pgaId } = useParams();
  const canViewPersonMembership = useCanViewPersonMembershipBool();
  const canManageApplications = useCanManageApplications();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const showProspectProgramTab = flagsLoaded && flags["backoffice-prospect-program-tab"] !== true;
  const showApplicationsTab = canManageApplications;

  const location = useLocation();
  const { pathname } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();

  if (!pgaId) return null;

  const tabOptions = [
    {
      label: "Overview",
      to: "/people/:pgaId/membership/overview" as Path,
      isAvailable: canViewPersonMembership
    },
    {
      label: "Path to Membership",
      to: "/people/:pgaId/membership/path-to-membership" as Path,
      isAvailable: canViewPersonMembership
    },
    {
      label: "Prospect Program",
      to: "/people/:pgaId/membership/prospect-program" as Path,
      isAvailable: canViewPersonMembership && showProspectProgramTab
    },
    {
      label: "Applications",
      to: "/people/:pgaId/membership/applications" as Path,
      isAvailable: showApplicationsTab
    },
    {
      label: "Section Affiliation",
      to: "/people/:pgaId/membership/section" as Path,
      isAvailable: true
    },
    {
      label: "Committees",
      to: "/people/:pgaId/membership/committees" as Path,
      isAvailable: true
    }
  ];

  const tabItems = tabOptions
    .filter((tab) => tab.isAvailable)
    .map(({ label, to }) => ({
      label,
      onClick: () => navigate(to, { params: { pgaId } }),
      active: currentUrl === to.replace(":pgaId", pgaId)
    }));

  return (
    <>
      <Tabs tabItems={tabItems} />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
